import * as React from 'react';
import { memo } from 'react';

const NYCOccupancy = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.1667 3.33301V8.33301M10.5 3.33301V8.33301"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.8359 21.6663V19.1663C33.8359 12.8809 33.8359 9.73826 31.8833 7.78562C29.9308 5.83301 26.7879 5.83301 20.5026 5.83301H17.1693C10.8839 5.83301 7.74119 5.83301 5.78855 7.78562C3.83594 9.73826 3.83594 12.8809 3.83594 19.1663V23.333C3.83594 29.6183 3.83594 32.7612 5.78855 34.7137C7.74119 36.6663 10.8839 36.6663 17.1693 36.6663H19.6693"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M23.8359 32.5003C23.8359 32.5003 26.0834 33.3448 27.1693 36.667C27.1693 36.667 32.4634 28.3337 37.1693 26.667"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66406 14.167H32.9974"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Memo = memo(NYCOccupancy);
export default Memo;
